import { useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown, Camera } from "lucide-react";
import { NavbarMenuItemProps } from "./types";

interface MobileNavItemGroupProps {
  title: string;
  isOpen: boolean;
  toggleDropdown: () => void;
  items: NavbarMenuItemProps[];
  closeMenu: () => void;
}

export const MobileNavItemGroup = ({ title, isOpen, toggleDropdown, items, closeMenu }: MobileNavItemGroupProps) => {
  const [openSubmenu, setOpenSubmenu] = useState<string | null>(null);
  
  const toggleSubmenu = (path: string, e: React.MouseEvent) => {
    if (items.find(item => item.path === path)?.submenu) {
      e.preventDefault();
      setOpenSubmenu(openSubmenu === path ? null : path);
    }
  };

  return (
    <div>
      <button 
        className="w-full flex justify-between items-center px-3 py-2 rounded-md text-base font-medium text-fabre-gray hover:text-fabre-green hover:bg-gray-100" 
        onClick={toggleDropdown}
      >
        {title}
        <ChevronDown className={`ml-1 h-4 w-4 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>
      
      {isOpen && (
        <div className="pl-4">
          {items.map(item => (
            <div key={item.path}>
              <Link 
                to={item.path} 
                className="flex justify-between items-center px-3 py-2 text-base font-medium text-fabre-gray hover:text-fabre-green hover:bg-gray-100" 
                onClick={(e) => item.submenu ? toggleSubmenu(item.path, e) : closeMenu()}
              >
                <div className="flex items-center">
                  {item.icon && <item.icon className="h-4 w-4 mr-2" />}
                  {item.name === "Photos des sites" && <Camera className="h-4 w-4 mr-2" />}
                  {item.name}
                </div>
                {item.submenu && (
                  <ChevronDown className={`ml-1 h-4 w-4 transition-transform ${openSubmenu === item.path ? 'rotate-180' : ''}`} />
                )}
              </Link>
              
              {item.submenu && openSubmenu === item.path && (
                <div className="pl-4">
                  {item.submenu.map(subItem => (
                    <Link 
                      key={subItem.path} 
                      to={subItem.path} 
                      className="flex items-center px-3 py-2 text-sm font-medium text-fabre-gray hover:text-fabre-green hover:bg-gray-100" 
                      onClick={closeMenu}
                    >
                      {subItem.icon && <subItem.icon className="h-4 w-4 mr-2" />}
                      {subItem.name}
                    </Link>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export const MobileNavigation = ({ 
  isMenuOpen, 
  toggleMenu,
  openDropdown,
  toggleDropdown,
  services,
  serviceOfferings,
  valorisations,
  groupItems,
  sitesItems,
  valocapItems
}: {
  isMenuOpen: boolean;
  toggleMenu: () => void;
  openDropdown: string | null;
  toggleDropdown: (dropdown: string) => void;
  services: NavbarMenuItemProps[];
  serviceOfferings: NavbarMenuItemProps[];
  valorisations: NavbarMenuItemProps[];
  groupItems: NavbarMenuItemProps[];
  sitesItems: NavbarMenuItemProps[];
  valocapItems: NavbarMenuItemProps[];
}) => {
  if (!isMenuOpen) return null;

  return (
    <div className="md:hidden">
      <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
        <Link to="/" className="block px-3 py-2 rounded-md text-base font-medium text-fabre-gray hover:text-fabre-green hover:bg-gray-100" onClick={toggleMenu}>
          Accueil
        </Link>
        
        <MobileNavItemGroup
          title="Nos clients"
          isOpen={openDropdown === 'mobileServices'}
          toggleDropdown={() => toggleDropdown('mobileServices')}
          items={services}
          closeMenu={toggleMenu}
        />
        
        <MobileNavItemGroup
          title="Nos Services"
          isOpen={openDropdown === 'mobileServiceOfferings'}
          toggleDropdown={() => toggleDropdown('mobileServiceOfferings')}
          items={serviceOfferings}
          closeMenu={toggleMenu}
        />
        
        <MobileNavItemGroup
          title="Valorisations"
          isOpen={openDropdown === 'mobileValorisations'}
          toggleDropdown={() => toggleDropdown('mobileValorisations')}
          items={valorisations}
          closeMenu={toggleMenu}
        />

        <MobileNavItemGroup
          title="Notre Groupe"
          isOpen={openDropdown === 'mobileGroup'}
          toggleDropdown={() => toggleDropdown('mobileGroup')}
          items={groupItems.map(item => 
            item.name === "Nos Sites" ? { ...item, submenu: sitesItems } : item
          )}
          closeMenu={toggleMenu}
        />
        
        <MobileNavItemGroup
          title="Valocap"
          isOpen={openDropdown === 'mobileValocap'}
          toggleDropdown={() => toggleDropdown('mobileValocap')}
          items={valocapItems}
          closeMenu={toggleMenu}
        />
        
        <Link to="/contact" className="block px-3 py-2 rounded-md text-base font-medium text-fabre-gray hover:text-fabre-green hover:bg-gray-100" onClick={toggleMenu}>
          Contact
        </Link>
      </div>
    </div>
  );
};
